@let isMobile = breakpoints() === "mobile";
<header>
  <div class="header-content">
    @if (data().image; as image) {
      <app-image [image]="image" [isPriority]="true" class="img-background" />
    }
    <div class="content-wrapper">
      <div class="row container">
        <div class="col-lg-12 col-xs-12">
          <div class="content">
            @if (subtitle()) {
              <app-title [titles]="[subtitle()]" />
            }
            @if (title()) {
              <app-title [titles]="[title()]" class="title" />
            }
            <div class="content-offset">
              <p [innerHTML]="data().text" class="text"></p>
              <div class="btn-actions">
                @if (data().cta; as btn) {
                  <app-button
                    (click)="onButtonClick(btn.label)"
                    [icon]="{ name: 'PLAY', position: 'LEFT', size: '16px' }"
                    [label]="btn.label"
                    [size]="isMobile ? 'SMALL' : 'NORMAL'"
                    [url]="btn.url"
                    theme="FULL_WHITE" />
                }
                @if (data().anchor && data().anchor.length > 0) {
                  <app-button
                    (buttonClicked)="goToSection(data().anchor[0]!.anchor); onButtonClick(data().anchor[0]!.label)"
                    [label]="data().anchor[0]!.label"
                    [size]="isMobile ? 'SMALL' : 'NORMAL'"
                    [style]=""
                    theme="FULL_WHITE" />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
